import { useTranslation } from "react-i18next";

import {
  KycModalBrowser,
  KycModalId,
  KycModalNoTablet,
  KycModalPrivacy,
} from "@/assets/icons/icons";

const prepItems = [
  { Icon: KycModalId, textKey: "portal:cockpit.idCheck.prep.validIdDocument" },
  {
    Icon: KycModalBrowser,
    textKey: "portal:cockpit.idCheck.prep.recommendedBrowsers",
  },
  { Icon: KycModalNoTablet, textKey: "portal:cockpit.idCheck.prep.noTablets" },
  { Icon: KycModalPrivacy, textKey: "portal:cockpit.idCheck.prep.privacy" },
] as const;

/** Prep checklist shown on the dedicated ID check page before external verification. */
export const KYCPrepInstructions = () => {
  const { t } = useTranslation();

  return (
    <ul className="flex list-none flex-col gap-3">
      {prepItems.map(({ Icon, textKey }) => (
        <li key={textKey} className="flex items-start gap-2">
          <Icon
            className="size-6 shrink-0 text-foreground-primary"
            aria-hidden
          />
          <span className="flex-1 text-body-base leading-md text-foreground-primary">
            {t(textKey)}
          </span>
        </li>
      ))}
    </ul>
  );
};
